import { Table } from 'flowbite-react';
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { serverURL } from '../../constants';

const UserTable = ({ datas }) => {

    const [editing, setEditing] = useState(null);
    const [form, setForm] = useState({ email: '', mName: '', type: '' });
    const [search, setSearch] = useState('');
    const adminHeaders = { headers: { 'x-admin-email': sessionStorage.getItem('email') } };

    function handleEdit(user) {
        setEditing(user._id);
        setForm({ email: user.email, mName: user.mName, type: user.type });
    }

    async function handleSave() {
        try {
            await axios.post(serverURL + '/api/profile', {
                uid: editing,
                email: form.email,
                mName: form.mName,
                password: ''
            });
            toast.success('User updated');
            window.location.reload();
        } catch (error) {
            toast.error('Error updating user');
        }
    }

    async function handleChangeType(userId, newType) {
        try {
            await axios.post(serverURL + '/api/admin/changetype', {
                userId: userId,
                type: newType
            }, adminHeaders);
            toast.success('Subscription updated');
            window.location.reload();
        } catch (error) {
            toast.error('Error updating subscription');
        }
    }

    async function handleDelete(userId) {
        if (window.confirm('Are you sure you want to delete this user? This will also delete all their courses.')) {
            try {
                await axios.post(serverURL + '/api/deleteuser', { userId }, adminHeaders);
                toast.success('User deleted');
                window.location.reload();
            } catch (error) {
                toast.error('Error deleting user');
            }
        }
    }

    async function handleResetPassword(email) {
        const newPassword = window.prompt('Enter new password for ' + email + ':');
        if (newPassword) {
            try {
                await axios.post(serverURL + '/api/admin/reset-password', {
                    adminEmail: sessionStorage.getItem('email'),
                    userEmail: email,
                    newPassword: newPassword
                });
                toast.success('Password reset successfully');
            } catch (error) {
                toast.error('Error resetting password');
            }
        }
    }

    const filtered = datas.filter(u =>
        u.email.toLowerCase().includes(search.toLowerCase()) ||
        u.mName.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className='flex flex-col py-4'>
            <div className='px-4 mb-4'>
                <input
                    className='border border-black p-2 w-full max-w-md'
                    placeholder='Search users by name or email...'
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <span className='ml-4 text-gray-500'>{filtered.length} users</span>
            </div>

            {editing && (
                <div className='border border-black p-4 mx-4 mb-4'>
                    <h3 className='font-bold text-lg mb-3'>Edit User</h3>
                    <div className='grid grid-cols-3 gap-4'>
                        <div>
                            <label className='font-bold block mb-1'>Email</label>
                            <input className='border border-black w-full p-2' value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                        </div>
                        <div>
                            <label className='font-bold block mb-1'>Name</label>
                            <input className='border border-black w-full p-2' value={form.mName} onChange={e => setForm({ ...form, mName: e.target.value })} />
                        </div>
                        <div>
                            <label className='font-bold block mb-1'>Type</label>
                            <input className='border border-black w-full p-2' value={form.type} disabled />
                        </div>
                    </div>
                    <div className='mt-3 flex gap-2'>
                        <button onClick={handleSave} className='bg-black text-white px-4 py-2 font-bold'>Save</button>
                        <button onClick={() => setEditing(null)} className='border border-black px-4 py-2 font-bold'>Cancel</button>
                    </div>
                </div>
            )}

            <div className="overflow-x-auto">
                <Table>
                    <Table.Head className='border-b text-black'>
                        <Table.HeadCell className='font-black'>Email</Table.HeadCell>
                        <Table.HeadCell className='font-black'>Name</Table.HeadCell>
                        <Table.HeadCell className='font-black'>Type</Table.HeadCell>
                        <Table.HeadCell className='font-black'>Subscription</Table.HeadCell>
                        <Table.HeadCell className='font-black'>Actions</Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {filtered.map(user => (
                            <Table.Row key={user._id} className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black">
                                <Table.Cell className="whitespace-normal font-normal text-black dark:text-white">
                                    {user.email}
                                </Table.Cell>
                                <Table.Cell className="whitespace-normal font-normal text-black dark:text-white">{user.mName}</Table.Cell>
                                <Table.Cell className="whitespace-normal font-normal text-black dark:text-white">
                                    <span className={`px-2 py-1 text-xs font-bold ${user.type === 'forever' ? 'bg-green-100 text-green-800' : user.type === 'free' ? 'bg-gray-100 text-gray-800' : 'bg-blue-100 text-blue-800'}`}>
                                        {user.type}
                                    </span>
                                </Table.Cell>
                                <Table.Cell className="whitespace-normal font-normal text-black dark:text-white">
                                    <select
                                        className='border border-black p-1 text-sm'
                                        value={user.type}
                                        onChange={e => handleChangeType(user._id, e.target.value)}
                                    >
                                        <option value='free'>Free</option>
                                        <option value='Monthly Plan'>Monthly</option>
                                        <option value='Yearly Plan'>Yearly</option>
                                        <option value='forever'>Forever (Admin)</option>
                                    </select>
                                </Table.Cell>
                                <Table.Cell className="whitespace-normal font-normal">
                                    <div className='flex gap-1'>
                                        <button onClick={() => handleEdit(user)} className='border border-black px-2 py-1 text-xs'>Edit</button>
                                        <button onClick={() => handleResetPassword(user.email)} className='border border-blue-500 text-blue-500 px-2 py-1 text-xs'>Reset Pass</button>
                                        <button onClick={() => handleDelete(user._id)} className='border border-red-500 text-red-500 px-2 py-1 text-xs'>Delete</button>
                                    </div>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </div>
        </div>
    );
};

export default UserTable;
